module.exports = __webpack_public_path__ + "static/media/image_case_school.88af6fb1.png";